import React, { Fragment, useState, useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import requestApi from "../../services/requestApi.service";
import { dashboardFolderPermissionList } from './Constants';
import { getSessionValue } from '../../Common/Appcommon';

const FolderModal = (props) => {
    let { isOpen, closeModal, isEdit, folderData} = props;
    const [showModal, setShowModal] = useState(isOpen);
    const [formData, setFormData] = useState({});
    const [isDisablePermission, setDisablePermission] = useState(false);
    const [selectedPermission,setSelectedPermission] = useState(dashboardFolderPermissionList[0]);
    const { register, handleSubmit: handleActionFormSubmit, control, formState: { errors }, getValues } = useForm();

    // Function to toggle the modal
    const toggleModal = () => {
        setShowModal(prevState => !prevState);
        closeModal();
    };

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const submitForm = async (e) => {
        formData['visible_type'] = selectedPermission['value'];
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "FOLDER_ACTION",
            "FOLDER_OPERATION": formData['id'] === undefined ? "CREATE" : "UPDATE",
            "data" : formData,
        }
        let response = await requestApi.processServerRequest(params);
        if (response.issuccess) {
            let id = response.data;
            closeModal(true, id, formData.folder_name);
        }
    }

    const onPermissionChange = (selectedValue, fieldName) => {
        setSelectedPermission(selectedValue);
    }

    return (
        <Modal isOpen={isOpen} size={'md'} >
            <form id="folder-form" name="folder-form" onSubmit={handleActionFormSubmit(submitForm)}>
                <ModalHeader toggle={toggleModal}>
                    {formData['id'] === undefined ? "Create Folder" : "Update Folder"}
                </ModalHeader>
                <ModalBody>
                    <div className='form-conatiner'>
                        <div className='input-section'>
                            <label className={'workflow-lbl form-label'} htmlFor="folder_name">Folder Name</label>
                            <Controller
                                name="folder_name"
                                control={control}
                                rules={{ required: formData.folder_name === undefined || formData.folder_name === "" ? "Please provide folder name" : false }}
                                render={({ field }) => {
                                    return (
                                        <input
                                            {...field}
                                            type="text"
                                            name="folder_name"
                                            id="folder_name"
                                            value={formData.folder_name}
                                            autoComplete={"off"}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                onInputChange(e);
                                            }}
                                            className={`form-control ${errors.folder_name ? 'is-invalid' : ''}`}
                                        />
                                    );
                                }}
                            />
                            {errors.folder_name && <em className={`error invalid-feedback`}>{errors.folder_name.message}</em>}
                        </div>
                        <div className='input-section mt-2'>
                            <label className={'workflow-lbl form-label'} htmlFor="permission">Permission</label>
                            <Controller
                                name="permission"
                                control={control}
                                rules={{ required: Object.keys(selectedPermission).length === 0 ? "Please provide permission" : "" }}
                                render={({ field }) => {
                                    return (
                                        <Select
                                            {...field}
                                            placeholder={'---Choose One---'}
                                            menuPlacement={"auto"}
                                            menuPosition={'fixed'}
                                            name={"permission"}
                                            id={"permission"}
                                            className={`basic-multi-select ${errors.permission ? 'is-invalid' : ''}`}
                                            classNamePrefix="wa-select"
                                            value={selectedPermission}
                                            onChange={e => {
                                                onPermissionChange(e, "permission");
                                                field.onChange(e);
                                            }}
                                            options={dashboardFolderPermissionList}
                                        />
                                    );
                                }}
                            />
                            {errors.permission && <em className={`error invalid-feedback`}>{errors.permission.message}</em>}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <a className={`le-button lePrimaryBtn br-4`} onClick={(e) => { closeModal(false) }}>
                        {"Cancel"}
                    </a>
                    <Button className={`le-button lePrimaryBtn br-4`} color="primary" type={'submit'}>
                        {"Save"}
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    )
}

export default FolderModal;